// Copyright (c) Move Closer 2022.

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
const localEnv = ['local']

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
const productionEnv = ['production']

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
function getEnv (): string {
  return process.env.VUE_APP_ENV || 'production'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function isLocalEnv (): boolean {
  return localEnv.includes(getEnv())
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function isNonProductionEnv (): boolean {
  return !productionEnv.includes(getEnv())
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function isProductionEnv (): boolean {
  return productionEnv.includes(getEnv())
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function isStagingEnv (): boolean {
  return isNonProductionEnv() && !isLocalEnv()
}
